var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { ErrorType } from "../types/ErrorType";
import { errorParameterValues } from "./volumeWindow";
import { hasHttpResponse } from "./apiUtils";
var errorTypes = Object.values(ErrorType);
// The numeric type is shared by many errors; a translatable domain code is more specific.
function pickErrorCode(err) {
    if (err.code && errorTypes.includes(err.code)) {
        return { code: err.code, isDomainCode: true };
    }
    return { code: err.type || err.code || "-4", isDomainCode: false };
}
function parseServerErrors(errorsResponse) {
    var errors = [];
    if ((errorsResponse === null || errorsResponse === void 0 ? void 0 : errorsResponse.errors) && Array.isArray(errorsResponse.errors)) {
        errors.push.apply(errors, errorsResponse.errors.map(function (err) { return (__assign(__assign({}, pickErrorCode(err)), { message: err.message || "", field: err.field, parameters: err.parameters })); }));
    }
    return errors;
}
function extractFieldFromMessage(message) {
    var colonIndex = message.indexOf(":");
    if (colonIndex > 0) {
        var extractedField = message.substring(0, colonIndex).trim();
        var displayMessage = message.substring(colonIndex + 1).trim();
        return { fieldName: extractedField, displayMessage: displayMessage };
    }
    return { fieldName: undefined, displayMessage: message };
}
export function handleError(errorsResponse, formatMessage) {
    var serverErrors = parseServerErrors(errorsResponse);
    var fieldErrors = {};
    var modalErrors = [];
    serverErrors.forEach(function (serverError) {
        var code = serverError.code, isDomainCode = serverError.isDomainCode, message = serverError.message, field = serverError.field, parameters = serverError.parameters;
        var _a = extractFieldFromMessage(message), extractedField = _a.fieldName, displayMessage = _a.displayMessage;
        var errorMessage = displayMessage || message;
        var mappedField = field || extractedField;
        if (isDomainCode) {
            // A translated domain code is a whole sentence; the "field: text" split fits raw messages only.
            mappedField = field;
        }
        // The backend sentence is not guaranteed to be localized, so only a field-bound error may show it.
        var fieldBoundText = isDomainCode ? message : errorMessage;
        var untranslated = mappedField
            ? fieldBoundText
            : formatMessage({ id: "ui-br-legaldeposits.field.error.generic" });
        errorMessage = errorTypes.includes(code)
            ? formatMessage({
                id: "ui-br-legaldeposits.field.error.".concat(code),
                defaultMessage: untranslated,
            }, errorParameterValues(parameters))
            : untranslated;
        if (mappedField) {
            fieldErrors[mappedField] = errorMessage;
        }
        else {
            modalErrors.push(errorMessage);
        }
    });
    return { fieldErrors: fieldErrors, modalErrors: modalErrors };
}
export function readErrorCode(error) {
    return __awaiter(this, void 0, void 0, function () {
        var body, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!hasHttpResponse(error)) {
                        return [2 /*return*/, null];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, error.response.clone().json()];
                case 2:
                    body = (_e.sent());
                    return [2 /*return*/, (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : null];
                case 3:
                    _a = _e.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function readErrorMessage(error) {
    return __awaiter(this, void 0, void 0, function () {
        var body, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!hasHttpResponse(error)) {
                        return [2 /*return*/, null];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, error.response.clone().json()];
                case 2:
                    body = (_e.sent());
                    return [2 /*return*/, ((_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d.trim()) || null];
                case 3:
                    _a = _e.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function extractServerErrorMessage(error, formatMessage, fallback) {
    return __awaiter(this, void 0, void 0, function () {
        var data, _a, fieldErrors, modalErrors, messages, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(error !== null && typeof error === "object" && "response" in error)) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, error.response
                            .clone()
                            .json()];
                case 2:
                    data = _c.sent();
                    _a = handleError(data, formatMessage), fieldErrors = _a.fieldErrors, modalErrors = _a.modalErrors;
                    messages = __spreadArray(__spreadArray([], modalErrors, true), Object.entries(fieldErrors).map(function (_a) {
                        var field = _a[0], message = _a[1];
                        return "".concat(field, ": ").concat(message);
                    }), true);
                    if (messages.length > 0) {
                        return [2 /*return*/, messages.join(" ")];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, fallback];
            }
        });
    });
}
export function applyFieldErrors(fieldErrors, setError) {
    Object.entries(fieldErrors).forEach(function (_a) {
        var fieldName = _a[0], message = _a[1];
        setError(fieldName, {
            type: "server",
            message: message,
        });
    });
}
export function formatModalErrors(modalErrors) {
    if (modalErrors.length === 0)
        return "";
    if (modalErrors.length === 1)
        return modalErrors[0];
    return modalErrors.map(function (error, index) { return (React.createElement("div", { key: index },
        index + 1,
        ". ",
        error)); });
}
